import {Injectable, Signal, signal, WritableSignal} from '@angular/core';
import {map, Observable, tap} from "rxjs";
import {environment} from "../../environments/environment";
import {HttpMethod} from "../constants/http-method";
import {ApiClientService} from "./common/api-client.service";
import {Site} from '../models/site/site';
import {LocalStorageService} from './common/local-storage.service';
import {SaveSiteDto} from '../dtos/site/save-site-dto';
import {ListPaginated} from '../dtos/list-paginated';
import {SearchSiteDto} from '../dtos/site/search-site-dto';
import {FileService} from './common/file.service';

@Injectable({
  providedIn: 'root'
})
export class SiteService {

  readonly prefixUrl = "/sites";
  private readonly _currentSiteSelected: WritableSignal<Site> = signal<Site>(new Site());
  public readonly currentSiteSelected: Signal<Site> = this._currentSiteSelected.asReadonly();
  private readonly _KEY_CURRENT_SESSION_SITE_SELECTED: string = 'current_session_site_selected';

  constructor(
    private readonly apiClientService: ApiClientService,
    private readonly localStorageService: LocalStorageService,
    private readonly fileService: FileService
  ) {
    this.initCurrentSelectedSite();
  }

  public getAllSites(active: boolean = false): Observable<Site[]> {
    let body = {};
    if(active) {
      body = { active: true }
    }
    return this.apiClientService
      .execute(environment.BASE_URL_API + this.prefixUrl + "/all",
        HttpMethod.POST, body
      );
  }

  public getSites(body: SearchSiteDto): Observable<ListPaginated<Site>> {
    return this.apiClientService
      .execute(environment.BASE_URL_API + this.prefixUrl + "/list",
        HttpMethod.POST, body
      );
  }

  public saveSite(body: SaveSiteDto): Observable<Site> {
    return this.apiClientService
      .execute(environment.BASE_URL_API + this.prefixUrl + "/save",
        HttpMethod.POST, body
      ).pipe(
        map(value => Object.assign(new Site(), value))
      );
  }

  exportExcelSite(body: SearchSiteDto): Observable<void>{
    return this.apiClientService.execute(
      environment.BASE_URL_API + this.prefixUrl + "/export-excel",
      HttpMethod.POST,
      body.toData(),
      null,
      undefined,
      "blob"
    ).pipe(
      tap((data: any) => {
        this.fileService.downloadFile("inventory.xlsx", data);
      })
    )
  }

  public setCurrentSiteSelected(site: Site): void {
    this._currentSiteSelected.set(Object.assign(new Site(), site));
    this.localStorageService.saveData(
      this._KEY_CURRENT_SESSION_SITE_SELECTED, site
    );
  }

  private getCurrentSiteSelected(): Site {
    const site: any = this.localStorageService.getData(this._KEY_CURRENT_SESSION_SITE_SELECTED);
    if(site) {
      return Object.assign(new Site(), site);
    }
    return new Site();
  }

  private initCurrentSelectedSite(): void {
    this._currentSiteSelected.set(
      this.getCurrentSiteSelected()
    );
  }
}